export default __webpack_public_path__ + "static/media/B_sound.daebeee4.mp3";